import { useTranslation } from "react-i18next";

import { Form } from "react-bootstrap";

function RCPInvoiceForm({ rcpInvoice, setRCPInvoice }) {
  const { t } = useTranslation();
  return (
    <div className="invoice-page__modal_form_invoice-container">
      <Form.Group>
        <Form.Label>Information sur la profession: </Form.Label>
        <Form.Control
          label="text"
          as="textarea"
          rows={8}
          value={rcpInvoice.information_on_profession}
          onChange={(e) =>
            setRCPInvoice({
              ...rcpInvoice,
              information_on_profession: e.target.value,
            })
          }
        />
      </Form.Group>
    </div>
  );
}

export default RCPInvoiceForm;
